import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { StorageService } from './storage.service';
import { User } from 'src/app/classes/User.class';
import { LoginResponseInterface } from './interfaces/login-response.interface';
import { STORAGE_TOKEN_USER_TOKEN, STORAGE_USER } from '../lib/contsants';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  getLoggedInName = new Subject();
  private apiTokenValue: LoginResponseInterface = null;
  private userValue: User = null;

  constructor(private storage: StorageService) {
    this.apiTokenValue = this.storage.getJSON(STORAGE_TOKEN_USER_TOKEN);
    this.userValue = this.storage.getJSON(STORAGE_USER);
  }

  set apiToken(token: LoginResponseInterface) {
    this.apiTokenValue = token;
    this.storage.storeJSON(STORAGE_TOKEN_USER_TOKEN, token);
    this.getLoggedInName.next(true);
  }

  logout() {
    this.apiTokenValue = null;
    this.storage.removeJSON(STORAGE_TOKEN_USER_TOKEN);
    this.storage.removeJSON(STORAGE_USER);
    this.getLoggedInName.next(false);
    localStorage.clear();
    setTimeout(() => {
      location.reload();
    }, 200);
    return true;
  }

  getapitoken() {
    this.apiTokenValue = this.storage.getJSON(STORAGE_TOKEN_USER_TOKEN);
    return this.apiTokenValue;
  }

  getUserToken(): Promise<LoginResponseInterface> {
    return new Promise((resolve, reject) => {
      if (!this.apiTokenValue) {
        reject();
        return;
      }

      resolve(this.apiTokenValue);
    });
  }

  clearToken() {
    this.apiTokenValue = null;
    this.storage.removeJSON(STORAGE_TOKEN_USER_TOKEN);
    this.storage.removeJSON(STORAGE_USER);
    localStorage.clear();
  }

  chekTokenisset() {
    const check = this.getapitoken();
    if (check) {
      const date = Date.now();
      const expires = check.expires;

      if (check.data === undefined) {
        return false;
      } else if (expires < date) {
        return false;
      } else {
        return true;
      }
    }
  }

  set user(user: User) {
    this.userValue = user;
    this.storage.storeJSON(STORAGE_USER, user);
  }

  get user(): User {
    return this.userValue;
  }

  get isLoggedIn() {
    return this.apiTokenValue !== null;
  }
}
